import { Fragment, type ReactNode, memo } from "react";

interface Props {
    subtitles: ReactNode[];
    title: ReactNode;
    items: ReactNode[];
    button: ReactNode;
}

export const HeroContentLayout = memo<Props>(function HeroContentLayout({ subtitles, title, items, button }) {
    return (
        <div className="con">
            <div className="sub">
                {subtitles.map((subtitle, index) => (
                    <Fragment key={`pm-subtitle-${index}`}>
                        {subtitle}
                        {index !== subtitles.length - 1 && <div className="dot"></div>}
                    </Fragment>
                ))}
            </div>
            <div className="ti">{title}</div>
            <div className="it">{items}</div>
            <div className="bt">{button}</div>
        </div>
    );
});
